import { Link } from "react-router-dom";
import { useSeo } from "../lib/seo";
import { PageHero } from "../components/shop/Common";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export const About = () => {
  useSeo({ title: "About Us", description: "Vacation Apparel creates funny, sarcastic and destination-inspired apparel so you can wear your vacation vibes." });
  return (
    <>
      <PageHero eyebrow="About us" title="Tell us where you're going. We'll help you dress for the adventure." subtitle="Wear Your Vacation Vibes!" />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-16 space-y-6 text-lg text-navy/80 leading-relaxed" data-testid="about-content">
        <p>Vacation Apparel was born from a simple idea: the best trips deserve their own outfits. Instead of scrolling through hundreds of random shirts, you tell us your destination and we show you apparel designed specifically for it.</p>
        <p>Every design is original — funny, sarcastic, sentimental or just plain sunny — and printed on demand, which means less waste and more vacation-ready style made just for you.</p>
        <p>Follow along and share your trips with us at <b>@VacationApparelUSA</b>.</p>
        <Link to="/destinations" className="inline-block rounded-full bg-sun px-8 py-3.5 font-bold text-navy">Find your destination</Link>
      </section>
    </>
  );
};

const FAQS = [
  ["How long will my order take?", "Every item is printed on demand. Production usually takes 2–7 business days, then U.S. shipping typically takes 3–8 business days. These are estimates, not guarantees."],
  ["Can I return my item?", "Because items are made to order, we can't accept returns for change of mind or wrong size. If your item arrives damaged or misprinted, contact us within 30 days and we'll make it right."],
  ["How do I find the right size?", "Each product page has a size guide. Most of our tees are a unisex fit — if you're between sizes, size up for a relaxed look."],
  ["Do you ship internationally?", "International shipping availability and rates will be shown at checkout."],
  ["How do I track my order?", "You'll receive a shipping confirmation email with tracking. You can also use the Track Order page."],
  ["My destination isn't listed — what now?", "We add new destinations regularly! Search for it anyway — we'll show similar spots — or send us a request through the Contact page."],
];

export const Faq = () => {
  useSeo({ title: "FAQ", description: "Answers about production times, shipping, sizing and returns at Vacation Apparel.", jsonLd: { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: FAQS.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })) } });
  return (
    <>
      <PageHero eyebrow="Help" title="Frequently asked questions" subtitle="Everything before takeoff." />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <Accordion type="single" collapsible data-testid="faq-accordion">
          {FAQS.map(([q, a], i) => (
            <AccordionItem key={q} value={`q${i}`}>
              <AccordionTrigger className="text-left text-lg font-bold text-navy" data-testid={`faq-item-${i}`}>{q}</AccordionTrigger>
              <AccordionContent className="text-navy/75 text-base leading-relaxed">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </>
  );
};
